module.exports = __webpack_public_path__ + "img/kep8.19993b71.jpg";